// 同步改变state
// 按类划分
// 命名：show/hide、get/set、add/reduce...
import ziMutations from './mutations_zi';
import luMutations from './mutations_lu';

const mainMutation = {
	/**
	 * 提示语
	 * **/
	showTooltip(state, { msg, icon, img, className, wrapClassName }) {
		state.tooltip = true;
		state.tooltip_msg = msg;
		state.tooltip_icon = icon;
		state.tooltip_img = img;
		state.tooltip_className = className;
		state.tooltip_wrapclassName = wrapClassName;
	},
	hideTooltip(state) {
		state.tooltip = false;
		state.tooltip_msg = '';
		state.tooltip_icon = '';
		state.tooltip_img = '';
		state.tooltip_className = '';
		state.tooltip_wrapclassName = '';
	},

	/**
	 * 显示名词解释弹框
	 * */
	showWordExplain(state, obj) {
		state.word_explain = true;
		state.word_explain_data = obj;
	},

	/**
	 * 隐藏名词解释弹框
	 * */
	hideWordExplain(state) {
		state.word_explain = false;
		state.word_explain_data = {};
	},

	/**
	 * vip开通成功后弹框
	 * **/
	showVipSuccess(state, obj) {
		state.vip_success = true;
		state.vip_success_desc = obj.desc;
		state.vip_expiration_date = obj.date;
		state.vip_success_close_callback = obj.callback;
	},

	hideVipSuccess(state) {
		state.vip_success = false;
		state.vip_success_desc = '';
		state.vip_expiration_date = null;
		state.vip_success_close_callback && state.vip_success_close_callback();
	},

	/**
	 * 招商证券重要声明
	 * **/
	showZsDeclaration(state, obj) {
		state.zs_declaration = true;
		state.zs_declaration_data = obj.data;
		state.zs_declaration_btn_callback = obj.callback || null;
	},

	hideZsDeclaration(state) {
		state.zs_declaration = false;
		state.zs_declaration_data = null;
	},

	/**
	 * loading
	 * **/
	showLoading(state) {
		state.loading = true;
	},

	hideLoading(state) {
		state.loading = false;
	},

	/**
	 * pending
	 * **/
	fetchPending(state) {
		state.fetch_pending = true;
	},

	fetchPendingSuccess(state) {
		state.fetch_pending = false;
	},

	/**
	 * 对话框
	 * **/
	setDialog(state, obj) {
		const {
			dialog_alert,
			dialog_affirm,
			dialog_text,
			dialog_title,
			dialog_cancel_text = '取消',
			dialog_confirm_text = '确认',
			dialog_text_class,
			dialog_alert_data
		} = obj;
		state.dialog_alert = dialog_alert;
		state.dialog_affirm = dialog_affirm;
		dialog_text && (state.dialog_text = dialog_text);
		dialog_title && (state.dialog_title = dialog_title);
		dialog_cancel_text && (state.dialog_cancel_text = dialog_cancel_text);
		dialog_confirm_text && (state.dialog_confirm_text = dialog_confirm_text);
		dialog_text_class && (state.dialog_text_class = dialog_text_class);
		dialog_alert_data && (state.dialog_alert_data = dialog_alert_data);
	},

	setDialogCancelBtn(state, fun) {
		state.dialog_cancel_btn = fun;
	},
	setDialogConfirmBtn(state, fun) {
		state.dialog_confirm_btn = fun;
	},

	setAuthDialog(state, obj) {
		console.log(obj);
		state.auth_dialog = obj.auth_dialog;
		obj.auth_dialog_type && (state.auth_dialog_type = obj.auth_dialog_type);
		state.auth_dialog_require = obj.auth_dialog_require;
		obj.auth_dialog_content && (state.auth_dialog_content = obj.auth_dialog_content);
		obj.auth_dialog_close__btn && (state.auth_dialog_close__btn = obj.auth_dialog_close__btn);
		obj.auth_dialog_success__btn && (state.auth_dialog_success__btn = obj.auth_dialog_success__btn);
	},

	/**
	 * app
	 * **/
	/**
	 * appClientInfo
	 * param { Object } appClientInfo
	 * */
	setAppClientInfo(state, appClientInfo) {
		state.appClientInfo = appClientInfo;
	},
	/**
	 * currentUserInfo
	 * param { Object } ui
	 * */
	setAppUserInfo(state, ui) {
		state.appUserInfo = ui;
	},

	/**
	 * 搜索
	 * **/
	setSearchKeyWord(state, kw) {
		state.searchKeyWord = kw;
	},

	clearSearchKeyWord(state) {
		state.searchKeyWord = '';
	},

	setIsBackFirstSearch(state, flag) {
		state.isBackFirstSearch = flag;
	},

	/**
	 * sliderItem
	 * **/
	setSliderItem(state, item) {
		state.sliderItem = item;
	},

	resetSliderItem(state) {
		state.sliderItem = null;
	},

	/**
	 * stropheMsg
	 * **/
	setStropheMsg(state, msg) {
		state.stropheMsg = msg;
	},

	/* AgoraClient*/
	setAgoraClient(state, client) {
		state.agoraClient = client;
	},

	setWxConfigUrl(state, url) {
		state.wxConfigUrl = url;
	},

	setPlayerAreaRatio(state, ratio) {
		state.playerAreaRatio = ratio;
	},

	setSignBase64(state, base64) {
		state.signBase64 = base64;
	},

	addRoomOnlineTimer(state, timer) {
		clearInterval(state.liveRoomOnlineTimer);
		state.liveRoomOnlineTimer = timer;
	},

	reduceRoomOnlineTimer(state) {
		clearInterval(state.liveRoomOnlineTimer);
	},

	setCompanyName(state, name) {
		state.companyName = name;
	},

	setCompanyType(state, type) {
		state.companyType = type;
	},

	setIsALiPayCallBack(state, isBack) {
		state.isALiPayCallBack = isBack;
	},

	setKeepAlive(state, routerName) {
		let index = state.keepAlive.indexOf(routerName);
		index === -1 && state.keepAlive.push(routerName);
	},

	removeKeepAlive(state, routerName) {
		let index = state.keepAlive.indexOf(routerName);
		index >= 0 && state.keepAlive.splice(index, 1);
	},

	setlocaleLang(state, lang) {
		state.localeLang = lang;
	},

	setLoginInfo(state, data) {
		state.loginInfo = data;
	},

	updateInitialsAreaCode(state, areaCode) {
		state.initialsAreaCode = areaCode;
	}
};

export default Object.assign(mainMutation, ziMutations, luMutations);
